<template>
  <div>
    <div class="form-item">
      <span class="label">*排序:</span>
      <el-input-number v-model="carouseInfo.sort" :min="1" style="width: 300px" />
    </div>
    <div class="form-item">
      <span class="label">*标题</span>
      <el-input
        v-model="listQuery.title"
        clearable
        style="width: 300px"
        maxlength="30"
        class="name-input"
        placeholder="请输入30字以内标题"
      />
    </div>
    <div class="form-item">
      <span class="label">*摘要</span>
      <el-input
        v-model="listQuery.abstract"
        type="textarea"
        :rows="6"
        placeholder="请输入70字以内摘要"
        resize="none"
        style="width: 300px"
      />
    </div>
    <div class="form-item">
      <span class="label">*上传封面</span>
      <!-- <el-upload
                class="upload-demo"
                drag
                action="https://jsonplaceholder.typicode.com/posts/"
                multiple
            >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>文件上传</em></div>
                <div slot="tip" class="">只能上传jpg/png文件，且不超过500kb</div>
            </el-upload> -->
      <el-upload
        :headers="headers"
        :show-file-list="false"
        :action="`${baseURL}/v1/app/UploadFile`"
        list-type="picture-card"
        :on-preview="handleImagePreview"
        :on-remove="handleImageRemove"
        :on-success="imageSuccess"
        :limit="1"
        accept="image/png,image/jpeg,image/gif,image/jpg"
      >
        <img v-if="carouseInfo.image" class="show-img" :src="imgDomain + carouseInfo.image" />
        <i v-else class="el-icon-plus"></i>
        <div slot="tip" class="el-upload__tip">建议尺寸为1920*580</div>
      </el-upload>
    </div>
    <div class="form-item">
      <span class="label">*上传白皮书</span>
      <el-upload
        :headers="headers"
        :action="`${baseURL}/v1/app/UploadFile`"
        :on-preview="handleImagePreview"
        :on-remove="handleImageRemove"
        :on-success="imageSuccess2"
        :limit="1"
        accept=".rar,.zip,.doc,.docx,.pdf,.jpg"
        class="upload-demo"
        :file-list="fileList"
      >
        <!-- <img v-if="carouseInfo.image2" class="show-img" :src="imgDomain + carouseInfo.image2" /> -->
        <el-button size="small" type="primary" class="addUpload">上传文件</el-button>
        <div slot="tip" class="addLimit">支持扩展名：.rar.zip.doc.docx.pdf.jpg...</div>
      </el-upload>
    </div>

    <el-dialog :visible.sync="dialogVisible"><img width="100%" :src="dialogImageUrl" alt="" /></el-dialog>
    <div class="form-item" style="justify-content: center; margin-top: 90px">
      <el-button type="primary" :loading="loading" plain style="margin-right: 40px" @click="back">取消</el-button>
      <el-button type="primary" :loading="loading" @click="onSaveClick">确定</el-button>
    </div>
  </div>
</template>
<script>
import { addIndustryInsight, editIndustryInsight, editScroll, detailsIndustryInsight } from "@/api/content";
import baseURL from "../../configs/baseUrl";
import utils from "@/jslibs/utils";
import { imgDomain } from "../../configs/env";
export default {
  data() {
    return {
      imgDomain,
      dialogImageUrl: "",
      dialogVisible: false,
      headers: {
        "X-Access-Token": utils.getCookie("X-Access-Token") || "",
      },

      baseURL,
      loading: false,
      fileList: [],
      carouseInfo: {
        image: "",
        show_type: "1",
        sort: "",
        banner_url: "",
        jump_url: "",
        jump_type: "2",
        alt: "",
        icon_image: "",
        h5_image: "",
        h5_icon_image: "",
      },
      textarea: "",
      // obj: {
      //     title: '',
      //     abstract: '',
      //     icon: '',
      //     file_info: ''
      // },

      listQuery: {
        title: "",
        abstract: "",
        icon: "",
        file_info: "",
      },
    };
  },
  mounted() {
    const { uuid } = this.$route.query;
    this.uuid = uuid;
    if (this.uuid) {
      this.getDetails(this.uuid);
    }
  },

  methods: {
    // 详情
    async getDetails(id) {
      console.log(id, 1231231);
      detailsIndustryInsight(id).then((res) => {
        console.log(res, 888888888);
        const obj = {
          title: res.title,
          abstract: res.abstract,
          icon: res.icon,
          file_info: res.file_info,
        };
        this.listQuery = obj;
        this.carouseInfo.image = obj.icon;
        this.fileList = [{ name: res.file_info, url: res.file_info }];
      });
    },
    // 编辑
    async editIndustryInsight() {
      // 传给数据
      const res = this.listQuery;
      const { result } = await editIndustryInsight(res);
    },

    // async addIndustryInsight(uuid) {
    //     const res = await getScrollDetail(uuid);
    //     this.carouseInfo = res;
    //     this.carouseInfo.show_type = String(this.carouseInfo.show_type);
    //     this.carouseInfo.jump_type = String(this.carouseInfo.jump_type);
    // },
    // async addIndustryInsight() {
    //     const obj = this.listQuery;
    //     // this.listLoading = true;
    //     const { total, data } = await customization(obj);
    //     // this.listLoading = false;
    //     // this.total = total;
    //     this.list = data;
    // },

    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handleImagePreview(file) {
      if (file.url) {
        this.dialogImageUrl = file.url;
      }
      this.dialogVisible = true;
    },
    handleImageRemove(file) {
      if (file.response && file.response.result) {
        this.carouseInfo.image = "";
      } else if (file.url) {
        this.carouseInfo.image = "";
      }
    },
    imageSuccess2(res, e) {
      // console.log(res, 88888)
      this.carouseInfo.image2 = res.result;
      this.listQuery.file_info = res.result;
    },
    imageSuccess(res, e) {
      // console.log(res, 88888)
      this.carouseInfo.image = res.result;
      this.listQuery.icon = res.result;
    },
    handleIconRemove(file) {
      if (file.response && file.response.result) {
        this.carouseInfo.icon_image = "";
      } else if (file.url) {
        this.carouseInfo.icon_image = "";
      }
    },
    iconSuccess(res, e) {
      this.carouseInfo.icon_image = res.result;
    },
    webIconSuccess(res, e) {
      this.carouseInfo.h5_icon_image = res.result;
    },
    handleWebRemove(file) {
      if (file.response && file.response.result) {
        this.carouseInfo.h5_image = "";
      } else if (file.url) {
        this.carouseInfo.h5_image = "";
      }
    },

    async onSaveClick() {
      if (!this.listQuery.title || !this.listQuery.abstract || !this.listQuery.file_info) {
        this.$message.error("请将内容填写完整");
        return;
      }

      const obj = this.listQuery;
      if (this.$route.query.uuid) {
        const { result } = await editIndustryInsight(this.$route.query.uuid, obj);
      } else {
        const { result } = await addIndustryInsight(obj);
        if (result) {
          this.tab = result.data;
        }
      }

      this.$router.push({
        name: "/industry-case",
      });

      // console.log()
      // this.list=data;

      // const { image, show_type, sort, banner_url, alt, icon_image, jump_type, jump_url, h5_icon_image, h5_image } = this.carouseInfo;
      // if (!image) {
      //     return this.$notify.error({ title: '请上传图片' });
      // }
      // if (!show_type) return this.$notify.error({ title: '请选择展示位置' });
      // if (!sort) return this.$notify.error({ title: '请选择排序' });
      // if (!banner_url) return this.$notify.error({ title: '请banner跳转链接' });
      // if (!icon_image) return this.$notify.error({ title: '请上传icon图标' });
      // if (!jump_type) return this.$notify.error({ title: '请选择icon跳转类型' });
      // if (jump_type == "1" && !jump_url) return this.$notify.error({ title: '请输入跳转链接' });
      // if (!h5_image) {
      //     return this.$notify.error({ title: '请上传H5banner图' });
      // }
      // if (!h5_icon_image) {
      //     return this.$notify.error({ title: '请上传H5 icon图' });
      // }
      // this.onSubmitClick()
    },
    async onSubmitClick() {
      if (this.uuid) {
        const res = await editScroll(this.uuid, this.carouseInfo);
        if (res == true) {
          this.$notify.success({ title: "编辑轮播图成功" });
        }
      } else {
        const res = await addIndustryInsight(this.carouseInfo);
        if (res == true) {
          this.$notify.success({ title: "新增成功" });
        }
      }
      this.$router.push({
        name: "/industry-case",
      });
    },
    back() {
      sessionStorage.removeItem("page_index");
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.form-item {
  display: flex;
  // align-items: center;
  margin: 20px;
  .icon_type {
    margin-right: 20px;
  }
}
.el-upload__tip {
  color: #606266 !important;
  font-size: 16px;
}
.addUpload {
  // margin-top: 20px;
}
.addLimit {
  color: #dcdfe6e0;
  font-size: 12px;
  margin-top: 10px;
}
.label {
  display: inline-block;
  width: 180px;
  flex-shrink: 0;
}
.show-img {
  width: 148px;
  height: 148px;
}
.el-upload__tip {
  color: red;
}
</style>
